import { reactotronRedux } from "reactotron-redux";
import Reactotron from "reactotron-react-js";

let reactotron;

if (__DEV__) {
  reactotron = Reactotron.configure({ name: "Sentimeter" })
    .use(reactotronRedux())
    .connect();

  console.r = Reactotron;
}

export default reactotron;
